import React, { useEffect, useState } from "react";

const Banner: React.FC = () => {
  const [username, setUsername] = useState<string | null>(null);

  useEffect(() => {
    const user = localStorage.getItem("user");
    setUsername(user? JSON.parse(user).username : null);
  }, []);

  return (
    <div className="relative h-20 bg-gray-900 text-white flex items-center justify-center">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: "url('/assets/images/banner-background.jpg')",
          filter: "brightness(0.5)",
        }}
      ></div>

      {/* Top-right Username */}
      <div className="absolute  right-4 z-20 text-sm font-medium bg-black bg-opacity-50 px-3 py-1 rounded">
        {username || "Guest"}
      </div>

      {/* Centered Content */}
      <div className="relative z-10 text-center flex flex-col items-center">
        <h1 className="text-2xl font-bold">KGN Infra</h1>
        <p className="mt-1 text-base flex items-center gap-2">
          <img
            src="/assets/tadwiro.png"
            alt="tadwiro"
            className="w-35 h-6 inline-block rounded"
          />
          <span>(Ayser World)</span>
        </p>
      </div>
    </div>
  );
};

export default Banner;